/* eslint-disable no-script-url */
/* eslint-disable jsx-a11y/media-has-caption */
import React, { useCallback } from 'react';

import { Button, Link, Grid, makeStyles, Typography } from '@material-ui/core';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';

import CaseActionsArchiveButton from './CaseActionsArchiveButton';
import CaseReportButton from './CaseReportButton';
import ScopicLogo from '../../assets/images/scopic-logo.png';
import { ACTIONS } from '../../constants/logs';
import LogService from '../../services/log.service';

const useStyles = makeStyles((theme) => {
  return {
    aiIcon: {
      color: '#999',
    },
    aiImage: {
      width: '80px',
    },
    aiMessage: {
      display: 'flex',
      gap: '6px',
      marginTop: '12px',
      width: '250px',
    },
    aiMessageContainer: {
      display: 'flex',
      flexDirection: 'column',
      gap: '8px',
      justifyContent: 'center',
      width: '250px',
    },
    downloadBtn: {
      color: theme.palette.primary.main,
    },
    greenBtn: {
      '&:hover': {
        backgroundColor: '#20794F',
      },
      backgroundColor: '#20794F',
    },
    link: {
      color: theme.palette.primary.main,
    },
    materialText: {
      fontFamily: 'Roboto',
      fontSize: '12px',
      fontStyle: 'normal',
      fontWeight: '500',
      lineHeight: '26px',
    },
    orangeBtn: {
      '&:hover': {
        backgroundColor: '#E2A74F',
      },
      backgroundColor: '#E2A74F',
    },
    purpleBtn: {
      '&:hover': {
        backgroundColor: '#787FF6',
      },
      backgroundColor: '#787FF6',
    },
    redOutlinedBtn: {
      '&:hover': {
        background: 'white',
        borderColor: '#B12A2A',
      },
      borderColor: '#B12A2A',
      color: '#B12A2A',
    },
    scopicPowered: {
      alignItems: 'center',
      color: '#555',
      display: 'flex',
      fontSize: '12px',
      fontWeight: 'bold',
      gap: '6px',
      justifyContent: 'center',
      textDecoration: 'none',
      width: '250px',
    },
    sectionHeader: {
      color: '#172B4D',
      fontSize: '18px',
      fontWeight: 'bold',
      marginBottom: '1rem',
    },
    sectionText: {
      color: '#999999',
      fontSize: '12px',
    },
    sectionTextIaMessage: {
      color: '#999999',
      fontSize: '12px',
      marginTop: '0px',
    },
    textWarning: {
      color: '#B12A2A',
    },
  };
});

const CaseActionsReportInformationAssigned = ({ caseStatus, onCaseAction, auth, isArchiving$ }) => {
  const classes = useStyles();
  const allowAiReports = process.env.REACT_APP_ALLOW_AI_REPORT === 'true';

  const logRecorderDownload = useCallback(() => {
    new LogService().create({
      action: ACTIONS.RECORDER_DOWNLOADED,
    });
  }, []);

  return (
    <Grid container direction="column" style={{ textAlign: 'left' }}>
      <Typography className={classes.sectionHeader}>Report information</Typography>
      <Typography className={classes.sectionText}>
        Your report will be created by accessing <br />
        the video recorder below. Please note that
        <br /> this recorder is only available on Windows.
      </Typography>

      <Button
        color="secondary"
        style={{ height: '40px', marginTop: '1rem', width: '250px' }}
        variant="contained"
        size="medium"
        onClick={() => onCaseAction(allowAiReports ? 'aiRecordModal' : 'record')}>
        Start Video Recorder
      </Button>

      {allowAiReports && (
        <Button
          color="primary"
          style={{ height: '40px', letterSpacing: 'normal', marginTop: '1rem', width: '250px' }}
          variant="contained"
          size="medium"
          onClick={() => onCaseAction('aiRecord')}>
          Start AI-Powered Video Recording
        </Button>
      )}

      {allowAiReports && (
        <div className={classes.aiMessageContainer}>
          <div className={classes.aiMessage}>
            <InfoOutlinedIcon className={classes.aiIcon} />
            <div className={classes.sectionTextIaMessage}>Using &quot;AI-Powered Video Recording&quot; will also automatically create a written report.</div>
          </div>

          <a className={classes.scopicPowered} href="https://scopicsoftware.com/ai-development-services/" target="_blank" rel="noreferrer">
            <span>POWERED BY</span> <img className={classes.aiImage} src={ScopicLogo} alt="Scopic" />
          </a>
        </div>
      )}

      <Link
        style={{ fontSize: '14px', marginTop: '1rem', textAlign: 'center', width: '250px' }}
        className={classes.downloadBtn}
        size="medium"
        href={process.env.REACT_APP_RECORDER_LINK}
        variant="button"
        target="_blank"
        onClick={logRecorderDownload}>
        Download latest version
      </Link>

      <Button
        classes={{
          outlinedPrimary: classes.redOutlinedBtn,
        }}
        style={{ backgroundColor: 'white', fontWeight: 'bold', marginTop: '1rem', width: '250px' }}
        variant="outlined"
        color="primary"
        size="medium"
        onClick={() => onCaseAction('optout')}>
        I cannot complete this report
      </Button>

      <div style={{ marginTop: '1rem', width: '250px' }}>
        <CaseActionsArchiveButton fullWidth size="medium" auth={auth} onCaseAction={onCaseAction} isArchiving$={isArchiving$} />
      </div>

      <div className={classes.reportButtonContainer}>
        <CaseReportButton caseReport={caseStatus?.data?.caseReport} caseId={caseStatus?.data?.id} />
      </div>
    </Grid>
  );
};

export default CaseActionsReportInformationAssigned;
